import { render } from "./BackAction.vue?vue&type=template&id=19c60836&scoped=true"
import script from "./BackAction.vue?vue&type=script&lang=js"
export * from "./BackAction.vue?vue&type=script&lang=js"

import "./BackAction.vue?vue&type=style&index=0&id=19c60836&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-19c60836"

export default script